import Vue from 'vue'
import Router from 'vue-router'
//引入nprogress
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //这个样式必须引入

Vue.use(Router)

//路由重复报错解决方法
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/index.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/Home.vue')
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: 'permission',
          name: 'permission',
          component: () => import('./views/sys/Permission.vue')
        },
        {
          path: 'role',
          name: 'role',
          component: () => import('./views/sys/Role.vue')
        },
        {
          path: 'user',
          name: 'user',
          component: () => import('./views/sys/User.vue')
        },
        {
          path: 'memberManage',
          name: 'memberManage',
          component: () => import('./views/member/MemberManage.vue')
        },
        {
          path: 'smsManage',
          name: 'smsManage',
          component: () => import('./views/sms/SmsManage.vue')
        },
        {
          path: 'taskManage',
          name: 'taskManage',
          component: () => import('./views/task/TaskManage.vue')
        }
      ]
    },{
      path: '/404',
      name: '/404',
      component: () => import('./views/404.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  if(to.name == null && to.path != '/index'){
    next({
      path: '/404'
    })
  }
  if(to.path == '/login' || to.path == '/index' || to.path == '/404'){
    next()
  } else{
    let userinfo= JSON.parse(localStorage.getItem("userinfo"))
    if(userinfo  != null){
      let menus = userinfo.menus
      var result = menus.findIndex(v => v.path == to.path)
      if(result < 0){
        next({
          path: '/404'
        })
      }
    }
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})
export default router;
